import { render } from "./ModalWithdrawBtcAccept.vue?vue&type=template&id=2f48e7b0&scoped=true&ts=true"
import script from "./ModalWithdrawBtcAccept.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawBtcAccept.vue?vue&type=script&lang=ts"

import "./ModalWithdrawBtcAccept.vue?vue&type=style&index=0&id=2f48e7b0&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f48e7b0"]])

export default __exports__